import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { Event as DeadlineIcon } from '@mui/icons-material';

import { getVehicleDeadlineWarnings } from '../../utils/vehicleDeadlines';

/** Warn-Chips für bald fällige bzw. überfällige Fahrzeugfristen (wie P-Schein-Chips bei Fahrern). */
const VehicleDeadlineChips = ({ vehicle }) => (
  getVehicleDeadlineWarnings(vehicle).map(deadline => (
    <Tooltip key={deadline.key} title={`${deadline.label}: fällig am ${deadline.date.toLocaleDateString('de-DE')}`}>
      <Chip
        label={deadline.status.label}
        size="small"
        icon={<DeadlineIcon />}
        color={deadline.status.color}
        variant="outlined"
        sx={{ height: 22, fontSize: '0.7rem' }}
      />
    </Tooltip>
  ))
);

export default VehicleDeadlineChips;
